import { DatePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { DiscussionComment } from '../../../types';

@Component({
  selector: 'app-discussion-thread-comment',
  imports: [DatePipe],
  templateUrl: './discussion-thread-comment.component.html',
  styleUrl: './discussion-thread-comment.component.scss',
})
export class DiscussionThreadCommentComponent {
  public comment = input.required<DiscussionComment>();
}
